<style>
.admin-page-html {
    max-height: none;
    overflow: auto;
}
</style>
<template>
    <div class="container tile" role="main" aria-labelledby="ImportHeading">
        <LoadingPlaceholder v-if="!loaded" />
        <template v-if="loaded">
            <div class="alert" style="padding: 5px" v-if="importSuccess != null" :class="importSuccess ? 'alert-success' : 'alert-danger'">
                <span v-if="importSuccess"> Successfully imported {{ imported }} submissions. </span>
                <dl v-else-if="Object.keys(errors).length > 0">
                    <template v-for="(messages, key) in errors">
                        <dt class="d-block">{{ key }}</dt>
                        <dd>
                            <ul>
                                <li v-for="message in messages">{{ message }}</li>
                            </ul>
                        </dd>
                    </template>
                </dl>
            </div>
            <div class="DFSectionHeading">
                <h1 class="admin-content-heading" id="ImportHeading">Import Form Data</h1>
                <p>Import form data directly into the system from a CSV.</p>
                <div class="DFSectionContents clearfix">
                    <form method="post" :action="formImportUrl" enctype="multipart/form-data">
                        <input type="hidden" id="RequestVerificationToken" name="__RequestVerificationToken" :value="xsrfToken" />
                        <div class="row no-gutters align-items-end mb-3">
                            <div class="col-md">
                                <div class="form-group mb-md-0 mr-md-2">
                                    <label class="control-label" for="Form">Form</label>
                                    <select name="form" id="Form" class="form-control" v-model="selectedForm">
                                        <option :value="null">-- Select a form --</option>
                                        <option v-for="formDef in sortedFormDefs" :value="formDef.Tenant + '`' + formDef.FormName + '`' + formDef.FormVersion">{{ formDef.FormTitle }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md">
                                <div class="form-group mb-md-0 mr-md-2">
                                    <label class="control-label" for="templateType">Format</label>
                                    <select name="templateType" id="templateType" class="form-control">
                                        <option>JSON</option>
                                        <option>CSV</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-auto">
                                <button type="submit" class="btn btn-primary form-control text-nowrap" name="Action" value="downloadTemplate" :disabled="selectedForm != null ? false : true">Download Template</button>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="control-label" for="CsvData">Submissions Data</label>
                            <div><input type="file" name="CsvData" id="CsvData" /></div>
                        </div>
                        <div class="form-group">
                            <label class="control-label" for="FileAttachmentsData">Submissions Attached Files (zip)</label>
                            <span class="editor-help-text">Attached file(s) are associated to a record by the filename, which is entered as the field value in the CSV.</span>
                            <div><input type="file" name="FileAttachmentsData" id="FileAttachmentsData" /></div>
                        </div>
                        <div class="form-group mt-4">
                            <button type="submit" class="btn btn-primary" name="Action" value="submit">Import</button>
                        </div>
                    </form>
                </div>
            </div>
        </template>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref, computed } from "vue";
import { computedAsync } from "@vueuse/core";
//import NonIndexStyles from '@/lib/nonIndexStyles.3.vue';
import { getXsrfToken } from "@/lib/getXsrfToken.3";
import LoadingPlaceholder from "@/lib/LoadingPlaceholder.3.vue";
import getData from "../../lib/getData";
import { useMainStore } from "@/mainStore";
import { Import } from "@cs/Import";
export default defineComponent({
    components: {
        LoadingPlaceholder,
    },
    setup() {
        const mainStore = useMainStore();
        const selectedForm = ref(null as Import["Form"] | null);
        const errors = ref({} as NonNullable<Import["Errors"]>);
        const imported = ref(0 as number | null);
        const importSuccess = ref(null as null | boolean);
        const formDefs = ref([] as Import["FormDefs"]);
        const loaded = ref(false);
        const sortedFormDefs = computed(() => {
            return [...formDefs.value!].sort((a, b) => a.FormTitle!.localeCompare(b.FormTitle!));
        });

        //const adminUrl = computedAsync(() => {
        //    return mainStore.getUrl("admin");
        //});
        const formImportUrl = computedAsync(() => {
            return mainStore.getUrl("adminFormImport");
        });
        const xsrfToken = computedAsync(() => {
            return getXsrfToken(mainStore);
        });

        loaded.value = false;
        (async () => {
            const formImportData = (await getData(mainStore, "AdminFormImport", () => mainStore.getUrl("adminFormImportData"))) as Import;
            formDefs.value = formImportData.FormDefs;
            errors.value = {};
            Object.keys(formImportData.Errors || {}).forEach(k => {
                errors.value![k] = formImportData.Errors![k];
            });
            importSuccess.value = formImportData.ImportSuccess ?? null;
            imported.value = formImportData.Imported ?? null;
            selectedForm.value = formImportData.Form ?? null;
            loaded.value = true;
        })();

        return {
            loaded,
            importSuccess,
            imported,
            errors,
            formImportUrl,
            selectedForm,
            sortedFormDefs,
            xsrfToken,
        };
    },
});
</script>
